import React, { useEffect } from "react";
import AllCategories from "../Categories/AllCategories";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";

const CategoriesP = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <AllCategories />
      <Footer />
    </>
  );
};

export default CategoriesP;
